import {
  RESET_KIT_TRANSFER,
  FETCH_KIT_TRANSFER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const kitTransferReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KIT_TRANSFER:
      return { data: action.payload };
    case RESET_KIT_TRANSFER:
      return initialState;
    default:
      return state;
  }
};

export default kitTransferReducer;
